module.exports = __webpack_public_path__ + "media/Estou.d6a31cf4.mp3";